import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { AnalyticsTrigger, Button, ChoiceGroup, Grid, GridColumn, Notice, Separator, TextField } from 'telia-front-react';
import { isLaptopOrTabletOrWatch, isDeviceWithImei } from '../stores/TradeInStore';
import { ValidationError } from './TradeInInterfaces';
import TradeInMultipleError from './TradeInMultipleError';
const FORM_ID = 'trade-in-form';
const TradeInForm = ({ tradeInStore: { isPriceFetching, isImeiFetching, isTradeInSubmitting, tradeIn, setTerms, setImeiOrSn, imeiFocused, imeiValidation: { response }, isPhone, formErrors, tradeInResponseHolder, selectedCategory, selectedCategoryId, onImeiFocus, onImeiBlur, isOrderValid, setDataConfirmationChecked, dataConfirmationChecked, correctDeviceConfirmationNeeded, correctDeviceConfirmationChecked, setCorrectDeviceConfirmationChecked, deviceLockConfirmed, setDeviceLockConfirmation, areConfirmationCheckboxesClicked, imeiOrSn }, tradeInStore, translate }) => {
    var _a, _b;
    const [imeiButtonClicked, setImeiButtonClicked] = React.useState(false);
    const [submitButtonClicked, setSubmitButtonClicked] = React.useState(false);
    useEffect(() => {
        return () => {
            setImeiButtonClicked(false);
            setSubmitButtonClicked(false);
        };
    }, []);
    const isImeiConfirmationButtonTextVisible = (imeiOrSn === null || imeiOrSn === void 0 ? void 0 : imeiOrSn.length) > 15 ? useMediaQuery({ query: '(min-width: 525px)' }) : useMediaQuery({ query: '(min-width: 385px)' });
    const imeiHelper = () => {
        if (isImeiFetching) {
            return { helpMessage: `${translate('tradeIn.form.imei.loading')}` };
        }
        else if (!imeiFocused && formErrors.get('imei')) {
            if (formErrors.get('imei') === 'NO_MATCH')
                return null;
            return { errorMessage: `${translate(`tradeIn.form.imei.errors.${formErrors.get('imei')}`)}` };
        }
        else if (response && response.success) {
            return { successMessage: `${translate(`tradeIn.form.${isLaptopOrTabletOrWatch(selectedCategoryId) ? 'imeiOrSn' : 'imei'}.success`)}` };
        }
        else if (imeiButtonClicked && !imeiOrSn) {
            return { errorMessage: `${translate('tradeIn.form.imei.errors.required')}` };
        }
        return {};
    };
    const termsHelper = () => {
        if (submitButtonClicked && !areConfirmationCheckboxesClicked) {
            return { errorMessage: `${translate('tradeIn.forms.termsHelper.label')}` };
        }
        return {};
    };
    const onSubmit = (event) => {
        event.preventDefault();
        setSubmitButtonClicked(true);
        if (isOrderValid()) {
            tradeIn();
        }
    };
    const validationChecks = [];
    if (correctDeviceConfirmationNeeded) {
        validationChecks.push({
            id: 'correctDevice',
            className: !correctDeviceConfirmationNeeded ? 'hidden' : '',
            disabled: isPriceFetching || isImeiFetching,
            labelText: `${translate('tradeIn.form.terms.label')}`,
            value: 'correctDevice',
            checked: correctDeviceConfirmationChecked,
            onChange: setCorrectDeviceConfirmationChecked
        });
    }
    if (!correctDeviceConfirmationNeeded || correctDeviceConfirmationChecked) {
        validationChecks.push({
            id: 'terms',
            labelText: `${translate('tradein.form.unlocked')}`,
            value: 'terms',
            className: formErrors.get('terms') && 'text-error',
            disabled: isPriceFetching || isImeiFetching,
            onChange: setDeviceLockConfirmation,
            input: {
                name: 'trade-in-agreement-additional-agreement'
            }
        });
        const translated = translate('tradeIn.form.terms.additionalInformation');
        validationChecks.push({
            id: 'confirmation',
            disabled: isPriceFetching || isImeiFetching,
            labelText: `${translated}`,
            children: translated,
            value: 'confirmation',
            onChange: setDataConfirmationChecked
        });
    }
    return (React.createElement(AnalyticsTrigger, { trigger: { id: `Submit - ${FORM_ID}`, callback: 'onSubmit' } },
        React.createElement("form", { id: FORM_ID, onSubmit: onSubmit },
            React.createElement("p", { className: "h5 text__margin-double" }, translate(`tradeIn.form.imei.description.${(_a = selectedCategory.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`)),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(Grid, { align: ['center-xs'] },
                React.createElement(GridColumn, { width: ['sm-12'] },
                    isDeviceWithImei(selectedCategoryId) && (React.createElement(Notice, null,
                        React.createElement("p", null, translate('tradeIn.form.imei.info')))),
                    React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                    React.createElement("form", { onSubmit: () => { } },
                        React.createElement(Grid, { gutter: "small", noWrap: true, align: ['bottom-xs'] },
                            React.createElement(GridColumn, { width: ['max'] },
                                React.createElement(TextField, { onFocus: onImeiFocus, type: "text", id: "imei-miniform", label: `${translate(`tradeIn.form.imei.label.${(_b = selectedCategory.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`)}`, ...imeiHelper(), input: {
                                        maxLength: isPhone ? 15 : 30
                                    }, onChange: setImeiOrSn, onBlur: onImeiBlur, value: imeiOrSn, isDisabled: isPriceFetching || isImeiFetching, isInvalid: (!imeiFocused && !!formErrors.get('imei')) || (imeiButtonClicked && !imeiOrSn) })),
                            React.createElement(GridColumn, { width: ['min'] },
                                React.createElement(Button, { iconRight: isImeiConfirmationButtonTextVisible ? '#arrow-right' : undefined, icon: isImeiConfirmationButtonTextVisible ? undefined : '#arrow-right', text: `${translate('tradeIn.form.confirm.label')}`, disabled: isPriceFetching || isImeiFetching, attributes: {
                                        type: 'submit'
                                    }, onClick: (e) => {
                                        e.preventDefault();
                                        setImeiButtonClicked(true);
                                        onImeiBlur();
                                    } })))))),
            response && [ValidationError.NO_MATCH_MULTIPLE, ValidationError.NO_MATCH].includes(response.error) && (React.createElement(React.Fragment, null,
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                !imeiFocused && React.createElement(TradeInMultipleError, { tradeInStore: tradeInStore, translate: translate }))),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            ((response === null || response === void 0 ? void 0 : response.success) || ['NO_MATCH', 'NO_MATCH_MULTIPLE'].includes(formErrors.get('imei'))) && (React.createElement(React.Fragment, null,
                React.createElement(ChoiceGroup, { id: "trade-in-agreement-additional-agreement", className: "text-left", label: 'trade-in-agreement-additional-agreement', type: "check", purpose: "agreement", hideLabel: true, value: ['confirmation', 'terms', 'correctDevice'].filter((_, index) => [dataConfirmationChecked, deviceLockConfirmed, correctDeviceConfirmationChecked][index]), onChange: (val) => {
                        setTerms(val.includes('terms'));
                    }, isInvalid: submitButtonClicked && !areConfirmationCheckboxesClicked, ...termsHelper(), background: "neutral-bg-level-2", options: validationChecks }),
                React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
                React.createElement(Button, { id: "tradein-submit-button", type: "expressive", text: `${translate('tradeIn.form.submit')}`, iconRight: "#arrow-right", isLoading: isTradeInSubmitting, disabled: isTradeInSubmitting || isPriceFetching || isImeiFetching, attributes: { type: 'submit' }, onClick: () => true }))),
            tradeInResponseHolder.error && (React.createElement(React.Fragment, null,
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                React.createElement(Notice, { type: "error" },
                    React.createElement(GridColumn, { width: ['xs-12'] },
                        React.createElement("p", null, translate(tradeInResponseHolder.error.key, tradeInResponseHolder.error.params))),
                    tradeInResponseHolder.error.linkToCart && (React.createElement(GridColumn, { width: ['xs-12'] },
                        React.createElement(Button, { url: `${tradeInStore.urlData.teliaShopURL}/checkout`, target: "_blank", text: `${translate('cart.check')}`, variant: "secondary", iconRight: "#arrow-right" })))))))));
};
export default observer(TradeInForm);
